function getActionUrlForYearFilter(button) {
    var date_range_middle_regex = /\/[\d]{4}-[\d]{4}\//g,
        date_range_end_regex = /\/[\d]{4}-[\d]{4}$/g,
        date_middle_regex = /\/[\d]{4}\//g,
        date_end_regex = /\/[\d]{4}$/g,
        params_regex = /\?.*$/g,
        date_range_middle_url = '',
        date_range_end_url = '',
        date_middle_url = '',
        date_end_url = '',
        params_url = '',
        action_url = $(button).parents('form').attr('action');

    date_range_middle_url = action_url.match(date_range_middle_regex);
    date_range_end_url = action_url.match(date_range_end_regex);
    date_middle_url = action_url.match(date_middle_regex)
    date_end_url = action_url.match(date_end_regex)
    params_url = action_url.match(params_regex);

    if (date_range_middle_url != '' && date_range_middle_url != null) {
        action_url = action_url.replace(date_range_middle_url, '');
    } else if (date_range_end_url != '' && date_range_end_url != null) {
        action_url = action_url.replace(date_range_end_url, '');
    } else if (date_middle_url != '' && date_middle_url != null) {
        action_url = action_url.replace(date_middle_url, '');
    } else if (date_end_url != '' && date_end_url != null) {
        action_url = action_url.replace(date_end_url, '');
    }

    if (params_url != '' && params_url != null) {
        action_url = action_url.replace(params_url, '');
    }

    return [action_url, params_url];
}

export {getActionUrlForYearFilter}